import namespace from '../../config/Namespace';

const types = {
  actions: {
    fetchClients: 'fetchClients',
    // Clients Details
    fetchClientDetails: 'fetchClientDetails',
    fetchClientDetailsSuccess: 'fetchClientDetailsSuccess',
    fetchClientDetailsFailure: 'fetchTransactionDetailsFailure',
    // Clients PaymentMethods
    fetchClientPaymentMethods: 'fetchClientPaymentMethods',
    fetchClientPaymentMethodsSuccess: 'fetchClientPaymentMethodsSuccess',
    // Clients History
    fetchClientHistory: 'fetchClientHistory',
    fetchClientHistorySuccess: 'fetchClientHistorySuccess',
    fetchClientHistoryFailure: 'fetchTransactionHistoryFailure',
    fetchClientHistoryLoading: 'fetchClientHistoryLoading',
    // Filters
    fetchClientFilters: 'fetchClientFilters',
    fetchClientFiltersSuccess: 'fetchClientFiltersSuccess',
  },
};

export default namespace('Clients', types);
